module.exports = __webpack_public_path__ + "static/media/CTY-ISC-lockup-landscape-alternative-logo-fullColour-rgb.b64e61cc.svg";